/** Thrown when binary or textual protocol data is malformed. */
export class ParseError extends Error {
  override name = 'ParseError';
  constructor(message: string, readonly offset?: number) {
    super(offset === undefined ? message : `${message} (at offset ${offset})`);
  }
}
